import React from 'react';

import { CurrentCharge, Invoice } from '@api/types';
import { TileWithLoading } from '@react/Pages/AccountSettingsPage/YourDataSection/TileWithLoading';
import CurrentChargeItem from './CurrentCharge';
import InvoiceItem from './Invoice';

interface InvoiceTileProps {
  href: string;
  invoices: Invoice[] | null;
  currentCharge: CurrentCharge | null;
  isNewBilling: boolean;
  isNewFeatureScopeActive: boolean;
}

const InvoicesTile: React.FC<InvoiceTileProps> = ({
  isNewFeatureScopeActive,
  invoices,
  currentCharge,
  isNewBilling,
  href,
}) => (
  <>
    <div className="your-data-card__title">{t('label.invoices')}</div>
    <div className="your-data-card__body flex-box-column">
      {(currentCharge || invoices) && (
        <div className="your-data-invoice-list">
          {currentCharge && !isNewFeatureScopeActive && !isNewBilling ? <CurrentChargeItem {...currentCharge} /> : null}

          {invoices?.map(invoice => (
            <InvoiceItem key={invoice.number} {...invoice} />
          ))}
        </div>
      )}

      {!currentCharge && !invoices && (
        <div className="your-data-card__empty-msg">{t('invoices.no-history.message')}</div>
      )}
    </div>
    <a className="your-data-card__action" href={href}>
      <i className="icon-show" />
    </a>
  </>
);

export default TileWithLoading(InvoicesTile);
